/**
 * Raw Auth0 configuration from Vite environment variables. You want
 * @see WfAuth0Config instead.
 */
export interface WfViteAuth0Config {
  readonly clientId: string;
  readonly domain: string;
  readonly tenantDomain: string;
}

/**
 * Auth0 configuration from environment.
 */
export interface WfAuth0Config extends WfViteAuth0Config {
  readonly isMock: boolean;
}

export function createWfAuth0ConfigFromEnv(): WfAuth0Config {
  if (!import.meta.env.VITE_WF_AUTH0_CONFIG) {
    throw new Error("VITE_WF_AUTH0_CONFIG is missing");
  }

  const config = JSON.parse(import.meta.env.VITE_WF_AUTH0_CONFIG) as WfViteAuth0Config;
  return {
    ...config,
    isMock: import.meta.env.VITE_WF_AUTHN_USE_MOCK === "true",
  };
}

let auth0Config: WfAuth0Config | undefined;

/**
 * Returns the Auth0 configuration from the Vite environment.
 */
export function getWfAuth0Config(): WfAuth0Config {
  if (!auth0Config) {
    auth0Config = createWfAuth0ConfigFromEnv();
  }
  return auth0Config;
}

/**
 * Returns true if the Auth0 client is configured to use the mock implementation.
 */
export function isWfAuthnMockEnabled(): boolean {
  const config = getWfAuth0Config();
  return config.isMock;
}
